import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import dayjs from "dayjs";

const ViewNotif = ({ open, onClose, notif }) => {
  if (!notif) return null;

  const groupedByCompany = notif.viewedBy?.reduce((acc, viewer) => {
    const company = viewer.companyName || "Unknown Company";
    if (!acc[company]) acc[company] = [];
    acc[company].push(viewer);
    return acc;
  }, {});

  const sortedCompanyNames = Object.keys(groupedByCompany || {}).sort();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" align="center">
          {notif.name}
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Box
          mb={2}
          sx={{
            fontSize: "16px",
            lineHeight: 1.6,
            wordBreak: "break-word",
            "& .ql-align-center": { textAlign: "center" },
            "& .ql-align-right": { textAlign: "right" },
            "& .ql-align-left": { textAlign: "left" },
          }}
          dangerouslySetInnerHTML={{ __html: notif.description }}
        />

        {notif.imgUrl && (
          <Box display="flex" justifyContent="center" mt={3}>
            <img
              src={notif.imgUrl}
              alt="Notification Visual"
              style={{ maxWidth: "100%", maxHeight: 300, borderRadius: 8 }}
            />
          </Box>
        )}

        {/* --- Users Viewed Section --- */}
        <Divider sx={{ my: 3 }} />
        <Typography variant="subtitle1" gutterBottom>
          Users Viewed: {notif.viewedBy?.length || 0}
        </Typography>

        {notif.viewedBy?.length > 0 ? (
          sortedCompanyNames.map((company) => (
            <Box key={company} mb={2}>
              <Typography variant="subtitle2" gutterBottom>
                {company}
              </Typography>
              {[...groupedByCompany[company]]
                .sort((a, b) => new Date(b.dateViewed) - new Date(a.dateViewed))
                .map((viewer, index) => (
                  <Typography key={index} variant="body2" sx={{ ml: 2 }}>
                    • {viewer.userName} ({viewer.user}) —{" "}
                    {dayjs(viewer.dateViewed).format("YYYY-MM-DD HH:mm")}
                  </Typography>
                ))}
            </Box>
          ))
        ) : (
          <Typography variant="body2" color="textSecondary">
            No users have viewed this notification.
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewNotif;
